import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface ExportPreviewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  titleSuffix: string;
  json: string;
}

export function ExportPreviewDialog({
  open,
  onOpenChange,
  titleSuffix,
  json,
}: ExportPreviewDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-3xl max-h-[80vh]">
        <DialogHeader>
          <DialogTitle>导出预览 - {titleSuffix}</DialogTitle>
        </DialogHeader>
        <div className="overflow-auto max-h-[60vh] bg-zinc-950 rounded-lg p-4">
          <pre className="text-xs text-zinc-300 font-mono whitespace-pre">
            {json}
          </pre>
        </div>
        <div className="flex justify-end gap-2">
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            关闭
          </Button>
          <Button onClick={() => navigator.clipboard.writeText(json)}>
            复制
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
